/**
 * @file legendary-card.component.ts
 * Carte de rareté LÉGENDAIRE.
 *
 * Effets visuels :
 * - Dégradé doré (#fde047 → #eab308 → #fbbf24)
 * - Bordure animée en rotation dorée
 * - Particules dorées ascendantes
 * - Paillettes montantes (carré scintillants)
 * - Couche d'étincelles cross color-dodge
 *
 * Usage :
 * ```html
 * <app-legendary-card [card]="cardData" />
 * ```
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { CardComponent } from '../card.component';
import {Card} from '@/app/shared/components/card/card.model';

@Component({
  selector: 'app-legendary-card',
  standalone: true,
  imports: [CardComponent],
  template: `
    <app-card
      rarity="LEGENDARY"
      [name]="card.name"
      [score]="score"
      [rating]="card.rating"
      [image]="card.fileName"
      [backOfCard]="card.extension.cardBack"
      [extensionId]="card.extension.id"
      [initiallyFlipped]="initiallyFlipped"
      [interactive]="interactive"
      [author]="card.author"
    />
  `,
  host: { style: 'display: block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendaryCardComponent {
  /** Données complètes de la carte à afficher. */
  @Input({ required: true }) card!: Card;

  /** Score obtenu pour ce tirage — propre à l'instance, pas à la carte. */
  @Input({ required: true }) score!: number;

  /** Si `true`, la carte démarre côté dos. */
  @Input() initiallyFlipped = false;

  /**
   * Si `false`, désactive le tilt souris + halo hover interne de `CardComponent`.
   * Utile quand le survol/zoom est déjà géré par un composant parent
   * (ex. `CardsLayerComponent.enableHoverZoom()` dans l'ouverture de booster),
   * pour éviter deux systèmes de hover concurrents sur le même élément.
   */
  @Input() interactive = true;
}
